import {
    ColumnActionsMode,
    DetailsList,
    FontIcon,
    IColumn,
    IDetailsListProps,
    Image,
    ImageFit,
    mergeStyles
} from "@fluentui/react"
import React from "react"

import { L10n } from "@encoway/l10n"

import { TranslationConstants } from "../../constants/translationConstants"
import { ResultBomProduct } from "../../features/bom/bomSlice"

const iconClass = mergeStyles({
    display: "flex",
    flexDirection: "row",
    justifyItems: "center",
    justifyContent: "center",
    fontSize: 32,
    height: 50,
    width: 75
})

const defaultColumnProps = {
    isResizable: false,
    columnActionsMode: ColumnActionsMode.disabled,
    onRender: (
        item: ResultBomProduct,
        index?: number | undefined,
        column?: IColumn | undefined
    ) => {
        const columnKey = column?.key as keyof ResultBomProduct
        return (
            column && (
                <span key={`row-${column.key}-${index}`}>
                    {item[columnKey]}
                </span>
            )
        )
    }
}

function renderProductImage(item: ResultBomProduct) {
    return item.productImage ? (
        <Image
            src={item.productImage}
            imageFit={ImageFit.contain}
            alt={`${item.name} Product Image`}
            width={75}
            height={50}
        />
    ) : (
        <FontIcon iconName="PictureFill" className={iconClass} />
    )
}

export default function ResultBomTable(props: Readonly<IDetailsListProps>) {
    const columns: IColumn[] = [
        {
            ...defaultColumnProps,
            key: "productImage",
            name: "",
            minWidth: 75,
            maxWidth: 75,
            onRender: renderProductImage
        },
        {
            ...defaultColumnProps,
            key: "quantity",
            name: L10n.format(
                TranslationConstants.Result.TABLE_HEADER_QUANTITY
            ),
            minWidth: 50,
            maxWidth: 50
        },
        {
            ...defaultColumnProps,
            key: "id",
            name: L10n.format(
                TranslationConstants.Result.TABLE_HEADER_ITEM_NUMBER
            ),
            minWidth: 100,
            maxWidth: 150
        },
        {
            ...defaultColumnProps,
            key: "name",
            name: L10n.format(TranslationConstants.Result.TABLE_HEADER_PRODUCT),
            minWidth: 100,
            maxWidth: 200
        }
    ]

    return <DetailsList {...props} columns={columns} />
}
